import React from 'react';
import LoginModal from './components/LoginModal';
import { render } from 'react-dom';

const App = () => {
	return <LoginModal />;
};

render(
	React.createElement(App),
	document.getElementById('login-modal-container')
);
